<template>
    <ValidatorMessage :message="ValidateMessage">
        <div class="d-flex form-control-email">
            <InputTextBase
                ref="inputref"
                v-model="value"
                :class="$attrs.class"
                :placeholder="props.placeholder ?? 'general.placeholderemail'"
                :select-on-focus="true"
                :autofocus="props.autofocus"
                :readonly="props.readonly"
                :disabled="props.disabled"
                :id="props.id"
                :label="props.label"
                :label-position="props.labelPosition"
                :maxlength="props.maxlength"
                :mark-text-part="props.markTextPart"
                type="email"
            />
            <!-- 
                TODO: Add click handler for InputTextBase icon, so we dont have to duplicate the Icon code here?
                Note: The icon and iconFamily props are not included in the IInputEmailProps since the icon is hardcoded here 
             -->
            <span
                class="input-group-text keep-icon border border-start-0"
                @click="sendEmail"
            >
                <IconComp icon="fa-at" />
            </span>
        </div>
    </ValidatorMessage>
</template>
<script setup lang="ts">
import { computed, ref, type ComponentPublicInstance } from 'vue';
import ValidatorMessage from './ValidatorMessage.vue';
import { ValidatorDef, type IEditorComponent } from '@/objects/gui';
import { useValidator } from '@/composeables';
import { IconComp, type IInputEmailModelValueType, type IInputEmailPropsWithoutModelValue } from '@/components';
import InputTextBase from './InputTextBase.vue';

defineOptions({ inheritAttrs: false });

const props = withDefaults(defineProps<IInputEmailPropsWithoutModelValue>(), {});

const modelValue = defineModel<IInputEmailModelValueType>({ required: true });

// The ref of the input element
const inputref = ref<ComponentPublicInstance<IEditorComponent> | null>(null);

const { Validate, ValidateMessage } = useValidator(
    new ValidatorDef({ Min: null, Max: null, Required: false, Type: 'email' }),
    modelValue.value,
)!;

const value = computed<string>({
    get() {
        return modelValue.value?.toString() || '';
    },
    set(value) {
        if (!Validate(value)) {
            return;
        }
        modelValue.value = value;
    },
});

/**
 * Send an email to the email address with the default email client
 */
const sendEmail = () => {
    if (value.value) {
        window.open(`mailto:${value.value}`);
    }
};

defineExpose<IEditorComponent>({ focus: () => inputref.value?.focus(), validateMessage: ValidateMessage });
</script>
